export const LOCAL_STORAGE_KEYS = {
	APP_MENU_STATE: "appMenu",
	CURRENT_PROFILE_TYPE: "current_profile_type",
	REDIRECT_PATH: "redirect_path",
	REDIRECT_PROFILE: "redirect_profile",
} as const;
